/**
 * Chat API Client
 *
 * Communicates with the backend chat proxy which forwards messages
 * to the Python agent's FastAPI server.
 */

import api from './index';

export const sendMessage = (message, pageContext = null) => {
  const body = { message };
  if (pageContext) body.pageContext = pageContext;
  return api.post('/chat', body);
};
export const resetChat = () => api.post('/chat/reset');
